// extracted by mini-css-extract-plugin
export default {"icon":"fullscreenControlButton-module__icon__TPqVQ","buttonContent":"fullscreenControlButton-module__buttonContent__rHErs"};